import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-548">
      <li className="flex" data-id="element-549">
        <span className="mr-2" data-id="element-550">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-551">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-552">
        <span className="mr-2" data-id="element-553">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-554">
          Photographs
        </Link>
      </li>
      <li className="flex" data-id="element-555">
        <span className="mr-2" data-id="element-556">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-557">
          Writing
        </Link>
      </li>
      <li className="flex" data-id="element-558">
        <span className="mr-2" data-id="element-559">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-560">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-561">
        <span className="mr-2" data-id="element-562">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-563">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-564">
        <span className="mr-2" data-id="element-565">↑</span>
        <Link to="/news" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-566">
          News
        </Link>
      </li>
      <li className="flex" data-id="element-567">
        <span className="mr-2" data-id="element-568">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-569">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;